import { render } from "./FlybyArrowLegend.vue?vue&type=template&id=24183580"
import script from "./FlybyArrowLegend.vue?vue&type=script&lang=js"
export * from "./FlybyArrowLegend.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__